import * as React from "react";
import { TutorialBackground } from "./TutorialBackground";
export var TutorialBlockInputs = function () {
    return React.createElement(TutorialBackground, null);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/TutorialBlockInputs.tsx
// module id = 668
// module chunks = 3